import axios, { AxiosResponse } from "axios";
import Swal from "sweetalert2";

const BASE_URL = "https://api.metricks.io";
// const BASE_URL = process.env.NEXT_PUBLIC_DEVELOPMENT_API_BASE_URL;
const API_URL = "https://resources.metricks.io/graphql";
const SIGNUP_API_ROUTE = `${BASE_URL}/auth/signup`;

const ACTIVATE_API_ROUTE = `${BASE_URL}/auth/activate`;

const SUBSCRIBE_API_ROUTE = `${BASE_URL}/subscribe`;
const CAMPAIGN_API_ROUTE = `${BASE_URL}/campaign`;
const CONTACT_US_ROUTE = `${BASE_URL}/contact-us`;

export const enum EmailStatus {
   LOADING,
   SUCCESS,
   VERIFIED,
   EXPIRED,
   BROKEN,
   ERROR,
}
export const verifyEmail = (token, setEmailStatus) => {
   axios
      .get(`${ACTIVATE_API_ROUTE}/${encodeURIComponent(token)}`)
      .then((res: AxiosResponse) => {
         res.data.message === "verified"
            ? setEmailStatus(EmailStatus.SUCCESS)
            : res.data.message === "alreadyVerified"
            ? setEmailStatus(EmailStatus.VERIFIED)
            : res.data.message === "expiredLink"
            ? setEmailStatus(EmailStatus.EXPIRED)
            : res.data.message === "brokenLink"
            ? setEmailStatus(EmailStatus.BROKEN)
            : setEmailStatus(EmailStatus.ERROR);
      })
      .catch((err) => {
         err.response && console.log(err.response.data);
         setEmailStatus(EmailStatus.ERROR);
      });
};

export const completeSignup = (integration, shop, dispatch, data, setIsLoading, router) => {
   console.log(data);
   const newData = {
      ...data,
      apiKey: decodeURIComponent(data.apiKey),
   };
   axios
      .post(`${SIGNUP_API_ROUTE}?integration=${integration}`, newData)
      .then((response) => {
         console.log(response.data.data.token);
         console.log(response.data);
         if (response.data.success) {
            dispatch({ type: "set_token", payload: response.data.data.token });
            localStorage.setItem("token", response.data.data.token);
            if (integration === "shopify") {
               localStorage.setItem("shop", shop);
               router.push("/signup/step-3");
            } else {
               console.log("here");
               localStorage.setItem("shop", shop);
               router.push("/signup/step-3");
            }
         } else {
            Swal.fire({
               icon: "error",
               title: "Oops...",
               text: "Something went wrong!",
            });
         }
      })
      .catch((err) => {
         console.log(err.response);
         Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${err.response.data.message}`,
         });
      })
      .then(() => setIsLoading(false));
};

export const signupAction = async (data) => {
   return await axios.post(SIGNUP_API_ROUTE, data);
};

export const sendCardDetails = (userToken, email, cardToken, router) => {
   const headers = {
      Authorization: `Bearer ${userToken}`,
   };
   axios
      .post(
         SUBSCRIBE_API_ROUTE,
         { email: email, source: cardToken, plan: "essential" },
         { headers }
      )
      .then((response) => {
         if (response.data.success) {
            router.push("/signup/step-3");
         } else {
            Swal.fire({
               icon: "error",
               title: "Oops...",
               text: "Something went wrong! Please try again!",
            });
         }
      })
      .catch((err) => {
         Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${err.response.data.message}`,
         });
      });
};

export const createCampaign = async (userToken, data) => {
   console.log(data);

   const headers = {
      Authorization: `Bearer ${userToken}`,
   };
   return await axios.post(CAMPAIGN_API_ROUTE, data, { headers });
};

export const startTheSignupProcess = (dispatch, router, data, userToken) => {
   // sign up
   const userData = localStorage.getItem("set_user");

   axios
      .post(SIGNUP_API_ROUTE, userData)
      .then((response) => {
         console.log(response.data.data.token);
         console.log(response.data);
         if (response.data.success) {
            localStorage.setItem("token", response.data.data.token);
            const headers = {
               Authorization: `Bearer ${userToken || response.data.data.token}`,
            };
            const authToken = response.data.data.token;
            axios
               .post(CAMPAIGN_API_ROUTE, data, { headers })
               .then((response) => {
                  if (response.data.success) {
                     localStorage.setItem("step", "done");
                     console.log(response.data);

                     router.push(`/app?token=${userToken || authToken}`);
                  } else {
                     dispatch({ type: "set_loading_true", payload: null });

                     Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong! Please try again!",
                     });
                  }
               })
               .catch((err) => {
                  console.log(err);
                  dispatch({ type: "set_loading_false", payload: null });

                  err.response && console.log(err.response);
                  err.response &&
                     Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: `${err.response.data.message}`,
                     });
               });
         } else {
            dispatch({ type: "set_loading_true", payload: null });

            Swal.fire({
               icon: "error",
               title: "Oops...",
               text: "Something went wrong during Signup, Please try again!",
            });
         }
      })
      .catch((err) => {
         dispatch({ type: "set_loading_true", payload: null });

         console.log(err);

         err.response && console.log(err.response);
         err.response &&
            Swal.fire({
               icon: "error",
               title: "Oops...",
               text: `${err.response.data.message}`,
            });
      });
};

export const contactUs = (data) => {
   axios
      .post(CONTACT_US_ROUTE, data)
      .then((response) => {
         Swal.fire({ icon: "success", title: "Sent Successfully", text: response.data?.message });
      })
      .catch((err) => {
         Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${err.response.data.message}`,
         });
      });
};

async function fetchAPI(query, { variables }: any = {}) {
   // Set up some headers to tell the fetch call
   // that this is an application/json type
   const headers = { "Content-Type": "application/json" };

   // build out the fetch() call using the API_URL
   // environment variable pulled in at the start
   // Note the merging of the query and variables
   const res = await fetch(API_URL, {
      method: "POST",
      headers,
      body: JSON.stringify({ query, variables }),
   });

   // error handling work
   const json = await res.json();
   // const resp = json.data.posts.edges;
   // console.log(json.data.posts.edges);
   if (json.errors) {
      console.log(json.errors);
      console.log("error details", query, variables);
      throw new Error("Failed to fetch API");
   }
   return json.data;
}

export const getAllPosts = async () => {
   const data = await fetchAPI(
      `
      query AllPosts {
        posts(first: 20, where: { orderby: { field: DATE, order: DESC}}) {
            edges {
                node {
                  id
                  title
                  link
                  modified
                  date
                  slug
                  excerpt
                  categories {
                    nodes {
                      name
                    }
                  }
                  featuredImage {
                    node {
                      fileSize
                      mediaType
                      mediaItemUrl
                      title
                      uri
                    }
                  }
                  author {
                    node {
                      name
                      username
                      userId
                      avatar {
                        url
                      }
                    }
                  }
                }
              }
        }
      }
      `
   );
   // console.log(data?.posts);

   return data?.posts.edges;
};

export const getPost = async (slug) => {
   // console.log(slug);
   const data = await fetchAPI(
      `
        fragment PostFields on Post {
          title
          excerpt
          slug
          date
          featuredImage {
            node {
              sourceUrl
            }
          }
        }
        query PostBySlug($id: ID!, $idType: PostIdType!) {
          post(id: $id, idType: $idType) {
            ...PostFields
            content
            author {
                node {
                  name
                  username
                  userId
                  avatar {
                    url
                  }
                  description
                }
            }
            categories {
                nodes {
                  name
                }
            }
            seo {
                canonical
                metaDesc
                metaKeywords
                opengraphAuthor
                opengraphDescription
                twitterTitle
                twitterDescription
                title
                breadcrumbs {
                  text
                  url
                }
                opengraphTitle
                opengraphSiteName
                opengraphImage {
                  sourceUrl
                }
                opengraphUrl
            }
          }
        }
      `,
      {
         variables: {
            id: slug,
            idType: "SLUG",
         },
      }
   );
   // console.log(data);

   return data?.post;
};

export const getCategories = async () => {
   const data = await fetchAPI(
      `
      query AllCategories {
         categories(first: 20) {
            edges {
              node {
                id
                name
              }
            }
         }
      }
      `
   );
   // console.log(data);

   return data?.categories.edges;
};

export const getPostsByCategory = async (name) => {
   console.log(name);
   const data = await fetchAPI(
      `
      query PostsByCategory($name: String!) {
         posts(first: 20, where: { categoryName: $name, orderby: { field: DATE, order: DESC} }) {
            edges {
               node {
                  id
                  title
                  link
                  modified
                  date
                  slug
                  excerpt
                  categories {
                     nodes {
                        name
                     }
                  }
                  featuredImage {
                     node {
                        fileSize
                        mediaType
                        mediaItemUrl
                        title
                        uri
                     }
                  }
                  author {
                     node {
                        name
                        username
                        userId
                        avatar {
                           url
                        }
                     }
                  }
               }
            }
         }
      }
      `,
      {
         variables: {
            name,
         },
      }
   );

   return data?.posts.edges;
};

export const getPostsByAuthor = async (userId) => {
   userId = parseInt(userId, 10);
   const data = await fetchAPI(
      `
      query PostsByAuthor($userId: Int!) {
         posts(first: 20, where: { author: $userId, orderby: { field: DATE, order: DESC} }) {
            edges {
               node {
                  id
                  title
                  link
                  modified
                  date
                  slug
                  excerpt
                  categories {
                     nodes {
                        name
                     }
                  }
                  featuredImage {
                     node {
                        fileSize
                        mediaType
                        mediaItemUrl
                        title
                        uri
                     }
                  }
                  author {
                     node {
                        name
                        username
                        userId
                        avatar {
                           url
                        }
                     }
                  }
               }
            }
         }
      }
      `,
      {
         variables: {
            userId,
         },
      }
   );

   return data?.posts.edges;
};
